import { Tag, Typography } from "antd";
import React from "react";
import { FolderChange } from "../../../redux/interfaces/folder.types.ts";
import { gray, lightBlue } from "../../../utils/theme/colors.ts";

interface Props {
  change: FolderChange;
}

export const HistoryAssignedUser: React.FC<Props> = ({ change }) => {
  const previousAssigned = change.assigned_user?.previous;
  const currentAssigned = change.assigned_user?.actual;

  return (
    <div className="flex items-center font-medium space-x-2 my-1">
      {currentAssigned !== null && (
        <div className="flex flex-wrap">
          <Typography.Text className="font-medium">
            Asignado:&nbsp;
          </Typography.Text>
          {previousAssigned !== null &&
            previousAssigned !== currentAssigned && (
              <div className="mr-1">
                <Tag color={gray}>{previousAssigned}</Tag>
                <span className="text-gray-500">→</span>
              </div>
            )}
          <Tag color={currentAssigned ? lightBlue : gray}>
            {currentAssigned}
          </Tag>
        </div>
      )}
    </div>
  );
};
